// extracted by mini-css-extract-plugin
export default {"mainNav":"index_mainNav_y4rdv"};